import React from 'react'

const NotificationSettings = () => {
  return (
    <div>NotificationSettings</div>
  )
}

export default NotificationSettings